import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AdorHeader from "./components/header/AdorHeader";
import PowertronFooter from './components/footer/PowertronFooter';
import AppRoutes from './routes';

function App() {
  return (
    <BrowserRouter>
      <AdorHeader />
      <AppRoutes />
      <PowertronFooter />
    </BrowserRouter>
  );
}

export default App;